import { isObject } from "lodash";

/**
 * This function accepts object param and returns all the trails this we can traverse the object
 * that will result in data the is not an array (because we don't want "a.1" "a.2"... for each row)
 * @see https://lowrey.me/getting-all-paths-of-an-javascript-object/
 * @param root - object
 */
export function getAllPaths(
  root: Record<string, unknown>
): Array<Array<string>> {
  const paths: Array<Array<string>> = [];
  const nodes: Array<{ obj: Record<string, unknown>; path: Array<string> }> = [
    {
      obj: root,
      path: [],
    },
  ];

  while (nodes.length > 0) {
    const node = nodes.pop();
    if (node == null || Array.isArray(node.obj)) {
      continue;
    }
    for (const key of Object.keys(node.obj)) {
      const path = [...node.path, key];
      paths.push(path);
      if (isObject(node.obj[key])) {
        nodes.unshift({
          obj: node.obj[key] as Record<string, unknown>,
          path,
        });
      }
    }
  }
  return paths;
}
